import { render, staticRenderFns } from "./order-confirmation-edit.vue?vue&type=template&id=46246dd9&scoped=true&"
import script from "./order-confirmation-edit.vue?vue&type=script&lang=js&"
export * from "./order-confirmation-edit.vue?vue&type=script&lang=js&"
import style0 from "./order-confirmation-edit.vue?vue&type=style&index=0&id=46246dd9&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46246dd9",
  null
  
)

export default component.exports